// import Swiper JS
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
// import Swiper styles
import 'swiper/css';
// import 'swiper/css/navigation';

const swiper = new Swiper('.popular-documents-swiper', {
    // slidesPerView: 1.5,
    slidesPerView: 1,
    breakpoints: {
      576: {
        // slidesPerView: 2.5,
        slidesPerView: popularDocuments && popularDocuments.layout && popularDocuments.layout == 'wide' ? 2.5 : 2,
        spaceBetween: 35
      },
      768: {
        // slidesPerView: 2.5,
        slidesPerView: popularDocuments && popularDocuments.layout && popularDocuments.layout == 'wide' ? 2.5 : 2,
        spaceBetween: 20
      },
      1125: {
        // slidesPerView: 3.5,
        slidesPerView: popularDocuments && popularDocuments.layout && popularDocuments.layout == 'wide' ? 3.5 : 3,
        // width: 1520
      }
    },
    modules: [ Navigation ],
    navigation: {
      nextEl: '.wpr-swiper-button-next',
      prevEl: '.wpr-swiper-button-prev'
    },
    spaceBetween: 20,
    // centeredSlides: true,
    height: 500
});
